<template>
  <div class="app-container">
    <router-view v-if="isRouteShow"></router-view>
  </div>
</template>

<script>
export default {
  // 组件的名字 在插件中可以看到 建议写上
  name: "app",
  data() {
    return {
      isRouteShow: true
    }
  },
  provide () {
    return {
      reload: this.reload
    };  
  },
  methods: {
    reload () {
     this.isRouteShow = false
     this.$nextTick(() => (this.isRouteShow = true))
   }  
  }
};
</script>

<style >
.app-container {
  height: 100%;
}
</style>
